/**
 * @deprecated Agent-level `status` was removed from the API.
 * Use `RpaAgentEffectiveStatus` for UX badges and
 * `RpaAgentSessionStatus` for session wire values.
 */
export default Object.freeze({
  Unknown: 0,
  Online: 1,
  Offline: 2,
  Disabled: 3,
});
